import styled from 'styled-components';

export const TextLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 700;
  margin-right: 3px;
`;

export const TextValue = styled.div`
  font-size: 15px;
`;
